import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DinominationsModalPageRoutingModule } from './dinominations-modal-routing.module';

import { DinominationsModalPage } from './dinominations-modal.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DinominationsModalPageRoutingModule,
    TranslateModule
  ],
  declarations: [DinominationsModalPage]
})
export class DinominationsModalPageModule {}
